import { ALL_LEGAL_ENTITY } from '~/constants/common';

export const getLE = (availableLe?: string[]) => {
  if (availableLe?.includes(ALL_LEGAL_ENTITY)) {
    return ALL_LEGAL_ENTITY;
  }
  return availableLe?.join(',');
};
